<template>
  <ResponsiveLayout
    spread-actions
    :progress="progress"
  >
    <template
      v-if="canGoBack"
      #header_start
    >
      <ButtonBack @click="navigateBack" />
    </template>
    <template #header_end><HeaderHelp /></template>

    <form
      id="name-input-form"
      data-qa="name-input-form"
      autocomplete="off"
      class="kds-main-wrapper"
      novalidate
      @submit.prevent="submit"
    >
      <div class="kds-content-block">
        <p class="kds-typography-title-xlarge">
          {{ $t('eu__name_input__title') }}
        </p>
        <p class="kds-typography-paragraph-large">
          {{ $t('eu__name_input__description') }}
        </p>
      </div>
      <div class="kds-content-block">
        <TextField
          :label="$t('eu__doctor_outreach_personal_information__first_name')"
          data-qa="first-name"
          autocomplete="given-name"
          v-bind="fieldAttrs.firstName"
        />
        <TextField
          :label="$t('eu__doctor_outreach_personal_information__last_name')"
          data-qa="last-name"
          autocomplete="family-name"
          v-bind="fieldAttrs.lastName"
        />
      </div>
    </form>

    <template #pre_actions>
      <TrustSignal
        :icon="isoIcon"
        :text="$t('trust_signal__iso')"
      />
    </template>
    <template #actions>
      <BaseButton
        :text="$t('generic_action_continue')"
        data-qa="submit"
        v-bind="submitAttrs"
        form="name-input-form"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import { ref, watch } from 'vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'
import HeaderHelp from '@eu/app/components/HeaderHelp.vue'
import TextField from '@shared/components/form/TextField.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import TrustSignal from '@shared/components/TrustSignal.vue'
import isoIcon from '@shared/assets/img/icon_iso.svg'
import useForm from '@shared/composables/useForm.js'
import useEuStore from '@eu/app/stores/useEuStore.js'
import useDoctorOutreachStore from '@eu/app/stores/useDoctorOutreachStore.js'
import useOnboardingProgress from '@eu/app/composables/useOnboardingProgress.js'
import useNavigation from '@eu/app/composables/useNavigation'
import ROUTE from '@eu/app/router/appModule/names'

const euStore = useEuStore()
const doctorOutreachStore = useDoctorOutreachStore()
const { progress } = useOnboardingProgress()
const { navigateNext, navigateBack, canGoBack } = useNavigation(
  ROUTE.NAME_INPUT,
)

const form = ref({
  firstName: euStore.formData.firstName || '',
  lastName: doctorOutreachStore.personalInformation.lastName || '',
})

watch(
  form,
  (value) => {
    euStore.updateFormData({
      firstName: value.firstName,
      lastName: value.lastName,
    })
    doctorOutreachStore.personalInformation = {
      ...doctorOutreachStore.personalInformation,
      firstName: value.firstName,
      lastName: value.lastName,
    }
  },
  { deep: true },
)

const { fieldAttrs, submitAttrs, submit } = useForm(
  form,
  ref({
    firstName: { validations: ['required'] },
    lastName: { validations: ['required'] },
  }),
  {
    onSubmit: () => {},
    onSuccess: () => {
      navigateNext()
    },
  },
)
</script>
